<template>
  <div class="header_base">
    <div class="header">
      <div class="left_button_area">
        <SpMenu
          class="sp-menu"
          :currentUser="currentUser"
          :menuMode="showMenu"
          @change_menu="toggleMenu">
        </SpMenu>
        <img src="/img/tokkyo.png">
        <img v-if="currentUser.is_login != '0'" :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon_sp" @click="page('/my-page')">
      </div>
      <img v-if="i18n_mode=='jp'" class="pc logo" src="/img/logo_pc.png?g=20221114" @click="page('/')">
      <img v-if="i18n_mode!='jp'" class="pc logo" src="/img/logo_pc_over.png?g=20221114" @click="page('/')">
      <div class="login_area">
        <div class="login">
          <span v-if="currentUser.is_login == '0'" class="login_box">
            <a @click="page('/login')" class="pc">{{t('ログイン')}}</a>
          </span>
          <img v-if="currentUser.is_login != '0'" :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon" @click="page('/my-page')">
          <img v-if="currentUser.is_login != '0'" src="/img/icons/point.png" class="pc point_icon">
          <span v-if="currentUser.is_login != '0'" class="pc point_block" @click="page('/buy-point')">
            {{currentUser.point | comma}}
          </span>
        </div>
        <div class="login coin">
          <img v-if="currentUser.is_login != '0'" src="/img/icons/coin.png" class="pc point_icon">
          <span v-if="currentUser.is_login != '0'" class="pc point_block"  @click="page('/exchange-card')">
            {{currentUser.coin | commaDecimal}}
          </span>
        </div>
      </div>
    </div>
    <div v-if="showMenu" class="menu_area">
      <div @click="page('/my-page')">マイページ</div>
      <div @click="page('/buy-point')">ポイント購入</div>
      <div @click="page('/buy-point-history')">ポイント履歴</div>
      <div @click="page('/buy-product-history')">商品購入履歴</div>
      <div @click="page('/exchange-card')">引換所</div>
      <div @click="page('/user-guide')">ご利用ガイド</div>
      <div @click="toiawase()">お問い合わせ</div>
      <div @click="page('/terms-of-service')">利用規約</div>
      <div @click="logout()" v-if="currentUser.is_login == '1'">ログアウト</div>
      <div @click="page('/login')" v-if="currentUser.is_login == '0'">ログイン</div>
    </div>
    <div>
      <div class="slick" v-if="isTop && bannerList && bannerMode == 1">
        <img v-for="(row, key) in bannerList.list" :key="key" :src="row.file_name">
      </div>
      <div class="movie_area" v-if="isTop && bannerMode == 2">
        <video src="/img/topmovie.mp4" autoplay muted loop playsinline />
      </div>
    </div>
    <AlertBanner
      v-if="isTop"
      imagePath="/img/top_banner/pc01.png?v=1"
      imagePathSp="/img/top_banner/sp01.png?v=1"
    ></AlertBanner>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
// import Tokkyo from '@/components/molecules/Header/Tokkyo.vue';
// import MainLogo from '@/components/atoms/MainLogo.vue';
import SpMenu from '@/components/molecules/SpMenu.vue';
import AlertBanner from '@/components/atoms/AlertBanner.vue';

export default {
  name: 'CommonHeader',
  mixins: [t],

  props: {
    availablePoint: {
      type: String,
      default: '0',
    },
    currentUser: {
      type: Object,
      default: () => {},
    },
    isTop: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showMenu: false,
  }),

  created() {
    if (this.isTop) {
      this.$store.dispatch('banner/getBannerList');
    }
  },

  mounted() {
    if (this.isTop) {
      window.$(window).off('resize');
      window.$(window).on('resize', () => {
        this.checkBreakPoint();
      });
    }
  },

  components: {
    // Tokkyo,
    // MainLogo,
    SpMenu,
    AlertBanner,
  },

  computed: {
    ...mapGetters({
      bannerMode: 'banner/bannerMode',
      bannerList: 'banner/bannerList',
    }),
  },

  watch: {
    bannerList() {
      setTimeout(() => {
        this.checkBreakPoint();
      }, 100);
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaDecimal(value) {
      return separateDecimalNumber(value);
    },
  },

  methods: {
    handleShopNameClick() {
      this.$emit('handleShopNameClick');
    },
    handlePointBoxClick() {
      this.$emit('handlePointBoxClick');
    },
    toggleMenu(mode) {
      this.showMenu = mode;
    },
    checkBreakPoint() {
      window.$('.slick.slick-initialized').slick('unslick');
      if (window.$(window).width() <= 768) {
        window.$('.slick').slick({
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 800,
          dots: true,
          arrows: true,
          centerMode: true,
          centerPadding: '5%',
        });
      } else {
        window.$('.slick').slick({
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 800,
          dots: true,
          arrows: true,
          variableWidth: true,
          centerMode: true,
          centerPadding: '15%',
        });
        window.$('.slick').slick('slickGoTo', 0, false);
      }
    },
    page(url) {
      this.$router.push(url);
      this.showMenu = false;
    },
    logout() {
      this.$store.dispatch('user/logOutUser');
    },
    toiawase() {
      window.open('https://www.iranoan.com/contacts');
    },
  },

};
</script>

<style lang="scss" scoped>
.header_base {
  padding-top: 105px;
}
.header {
  background-color: #fff;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  .left_button_area {
    display: flex;
    align-items: center;
    img {
      width: 56px;
      margin-left: 10px;
    }
    .rank_icon_sp {
      width: 32px;
      display: none;
        @media screen and  (max-width: $tabletWidth) {
          display: inline;
        }
    }
  }
  .sp-menu {
    width: 50px;
  }
  .login_area {
    display: flex;
    justify-content: flex-end;
    width: 120px;
    .login {
      display: flex;
      justify-content: center;
      align-items: center;
      .rank_icon {
        width: 52px;
        margin-right: 10px;
        @media screen and  (max-width: $tabletWidth) {
          display: none;
        }
      }
      .login_box {
        background-color: $mainColor;
        padding: 0 20px;
        border-radius: 10px;
        a {
          color: $white!important;
        }
      }
      .point_icon {
        width: 36px;
        z-index: 1;
      }
      .point_block {
        background-color: #fff;
        height: 26px;
        margin-left: -6px;
        z-index: 0;
        width: 90px;
        text-align: right;
        display: block;
        padding-right: 9px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        border: 1px solid #e7e7e7;
      }
    }
    .coin {
      margin-left: 10px;
    }
  }
}
.menu_area {
  display: flex;
  position: fixed;
  background: $mainColor;
  color: #fff;
  z-index: 10;
  width: 100%;
  justify-content: space-between;
  padding: 20px 50px;
  div {
    cursor: pointer;
    transition: .4s;
    &:hover {
      text-decoration: underline;
    }
  }
}
.logo {
  cursor: pointer;
  width: 196px;
}
.movie_area {
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and  (max-width: $tabletWidth) {
    background-color: #fff;
  }
  margin-bottom: 10px;
  video {
    max-width: 800px;
    width: 100%;
  }
}
.slick-track {
  img {
    margin: 10px 2px 0 2px!important;
    max-width: 600px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .header_base {
    padding-top: 72px;
  }
  .header {
    padding: 10px;
    .left_button_area {
      align-items: center;
      img {
        width: 36px;
        margin-left: 5px;
      }
    }
    .sp-menu {
      width: 40px;
    }
    .logo {
      width: 120px;
    }
    .login_area {
      width: 100px;
      flex-direction: column;
      .login {
        .login_box {
          padding: 5px 10px;
          font-weight: bold;
        }
        .point_icon {
          width: 28px;
        }
        .point_block {
          height: 20px;
          font-size: 14px;
          width: 70px;
          padding-right: 8px;
        }
      }
      .coin {
        margin: 5px 0 0 0;
      }
    }
  }
  .menu_area {
    position: fixed;
    flex-direction: column;
    justify-content: flex-start;
    width: auto;
    padding: 20px 50px 20px 20px;
    height: calc(100vh - 73px);
    div {
      padding: 10px 0;
      &:hover {
        text-decoration: auto;
      }
      &:last-child {
        margin-top: auto;
      }
    }
  }
}
</style>
